var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{class:{ 'default-color' : !_vm.color },attrs:{"transform":"scale(1, -1)","width":_vm.width,"height":_vm.height,"fill":_vm.color}},[_c('rect',{attrs:{"width":_vm.width,"height":_vm.height,"rx":_vm.roundedBorder,"fill-opacity":"0.1"}}),_c('rect',{attrs:{"width":_vm.width,"height":_vm.total,"rx":_vm.roundedBorder}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }